import moment from 'moment-timezone';
import { store } from '../redux/store';

export const constructSearchQueryParam = (filters) => {
  let queryPayload = {
    hierarchy_name: '',
    contact_name: filters.contactName,
    contact_email: filters.contactEmail,
    dba_name: filters.dbaName,
    child_id: filters.childId,
  };
  if (filters.hierarchy.length > 0) {
    filters.hierarchy.map((item) => {
      queryPayload = {
        ...queryPayload,
        hierarchy_name: `${queryPayload.hierarchy_name},${item.value}`,
      };
    });
  }
  queryPayload.hierarchy_name = queryPayload.hierarchy_name.replace(
    /(^,)|(,$)/g,
    ''
  );
  console.info('queryPayload', queryPayload);
  return queryPayload;
};
// Download API is discouraged to use RTK query as the downloaded file will also be cached
export const downloadFile = async (filePath, fileObject) => {
  const rootUrl = process.env.REACT_APP_ROOT_URL;
  const jwt = store.getState().authReducer.jwt;
  fetch(`${rootUrl}/download/${filePath}`, {
    method: 'GET',
    headers: { authorization: `Bearer ${jwt}` },
  })
    .then((res) => {
      return res.blob();
    })
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const fileName = `${fileObject.title}_${fileObject.id}${getDate(
        fileObject
      )}`;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
};

const getDate = (payload) => {
  let dateString = '';
  dateString += payload.start_date ? `_${moment(payload.start_date).format('YYYY-MM-DD')}` : '';
  dateString += payload.end_date ? `_${moment(payload.end_date).format('YYYY-MM-DD')}` : '';
  return dateString;
};
export const capitalizeFirstLetter = (value) => {
  return value.charAt(0).toUpperCase() + value.substring(1).toLowerCase();
};
export const readObjectValue = (parentObject, keyPath) => {
  const keyPathArray = keyPath.split('.');
  let nestedObj = parentObject;
  for (let i = 0; i < keyPathArray.length; i++) {
    nestedObj = nestedObj[keyPathArray[i]];
  }
  return nestedObj;
};
export const reformatTextCapitalizeFirstLetter = (word) => {
  return word.charAt(0).toUpperCase() + word.substring(1).toLowerCase();
};

export const getCorrespondingProductTypeFromProcessorList = (processorCredentialsList) => {
  const product = store.getState().persistedProductReducer.product
  return processorCredentialsList.filter((item) => {
    return item.key === product.details.type
  })
}

export const getCorrespondingProcessorTypeFromProductList = (productsListArray) => {
  const product = store.getState().persistedProductReducer.product
  return productsListArray.filter((item) => {
    return item.key === product.details.processor;
  })
}

export const getCorrespondingCredentialsArraySelectOptionsFromProcessorList = (credentialsArray) => {
  return credentialsArray.filter((item) => {
    return item.type === 'select'
  })
}

